module.exports = __webpack_public_path__ + "img/16-14-37.b48a30bf.png";